import React from "react"
import { Link } from "gatsby"
import Sticky from "react-sticky-el"
import { Nav } from "react-bootstrap"
// import "./header.css"
import "./header.module.css"
import "./header.css"

const Header = () => (
	<header>
		<Sticky
			id="sticky-wrapper"
			className="sticky-wrapper"
			stickyClassName="is-sticky"
			stickyStyle={{ transform: "unset", zIndex: "999" }}
		>
			<Nav
				className="navbar navbar-light navbar-expand-md navigation-clean"
				style={{ zIndex: "1" }}
			>
				<div className="container-fluid">
					<div className="row text-center w-100">
						<div className="col-md-12">
							<ul>
								<li className="d-inline">
									<Link
										className="navbar-brand"
										to="/"
										style={{ color: `#FFFFFF` }}
									>
										&nbsp; &nbsp; HOME
									</Link>
								</li>
								<li className="d-inline">
									<Link
										className="navbar-brand"
										to="/uiom"
										style={{ color: `#FFFFFF` }}
									>
										&nbsp; &nbsp; UIOM
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</Nav>
		</Sticky>
	</header>
)

export default Header
